'use client'

import { useIsFirstRender } from '@cdc-internal/fe-toolbox/react-hooks'
import { ClientOnly } from '@suspensive/react'

import { localDisableThirdPartyServices } from '@/configs/env'

import { initializeSegment } from './utils'

function Segment() {
  const isFirstRender = useIsFirstRender()

  if (isFirstRender) {
    initializeSegment()
  }

  return null
}

export default function SegmentWrapper() {
  if (localDisableThirdPartyServices) {
    return null
  }

  return (
    <ClientOnly fallback={null}>
      <Segment />
    </ClientOnly>
  )
}
